<template>
    <div class="scoreDetail" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="score-list" v-for="(item,index) in scoreDetail" :key="index">
        <div>
          <div class="fs-28">{{item.score_event_name_show}}</div>
          <div class="time">{{item.created_at}}</div>
        </div>
        <div class="score"><span>{{item.symbol == 1 ? '+' : '-'}}</span>{{item.score}}</div>
      </div>
      <!--加载下一页-->
      <div class="loading" style="margin-top: -.16rem" v-if="loading">
        <img src="../assets/images/loading.gif" alt="">
      </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {actions} from "../store/actions";
    import {InfiniteScroll} from 'mint-ui';
    Vue.use(InfiniteScroll);

    export default {
      name: "scoreDetail",
      data() {
        return {
          scoreDetail: [],
          page: 1,
          page_size: 20,
          hasMore: true,
          isOk: false,
          loading: false
        }
      },
      created() {
        this.$indicator.open()
        this.getScoreDetail(true);
      },
      methods: {
        getScoreDetail(flag) {
          let _this = this
          _this.isOk = false;
          if (!_this.hasMore) {
            return;
          }
          if (flag) {
            _this.scoreDetail = []
            _this.page = 1
          }
          let params = {
            uid: _this.$store.state.wxUid,
            page: _this.page,
            page_size: _this.page_size
          }
          actions.getScoreDetail(_this, params, function (res) {
            _this.$indicator.close();
            if (res != null && res.list.length > 0) {
              if (res.list.length < _this.page_size) {
                _this.hasMore = false
              }
              _this.page++;
              var scoreDetail = _this.scoreDetail.concat(res.list)
              _this.scoreDetail = scoreDetail
              _this.isOk = true
            } else {
              _this.hasMore = false
            }
          },function(){
            _this.$indicator.close();
          })
        },
        loadMore: function () {
          if (!this.hasMore) {
            return;
          }
          if(this.isOk){
            this.loading = true;
//          this.$indicator.open()
            setTimeout(() => {
              this.getScoreDetail(false)
              this.loading = false;
            }, 1000);
          }

        },
      }
    }
</script>

<style scoped>
  .scoreDetail {
    background: #fff;
    padding: .52rem .32rem;
    min-height: 100vh;
  }
  .score-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .57rem;
  }
  .time {
    font-size: .20rem;
    color: #B0B5BB;
  }
  .score {
    font-size: .48rem;
    color: #F15A5D;
  }
</style>



// WEBPACK FOOTER //
// scoreDetail.vue?8553c5c6